export default [
    { key: 'name', label: 'label.name', sortable: false, sortDirection: 'asc' },
    {
        key: 'firstname',
        label: 'label.firstname',
        sortable: true,
        sortDirection: 'asc',
    },
    {
        key: 'lastname',
        label: 'label.lastname',
        sortable: false,
        sortDirection: 'asc',
    },
    { key: 'email', label: 'label.email', sortable: true },
    { key: 'mobile_phone', label: 'label.mobilePhone', sortable: false },
    { key: 'title', label: 'label.title', sortable: false },
    {
        key: 'department',
        label: 'label.department',
        sortable: true,
        path: 'department.name',
    },
    { key: 'office', label: 'label.office', sortable: false },
    {
        key: 'usertype',
        label: 'label.usertype',
        sortable: false,
        path: 'usertype.name',
    },
    { key: 'role', label: 'label.role', path: 'role.name' },
]
